import { render, staticRenderFns } from "./VueSelect.vue?vue&type=template&id=0c026f40&"
import script from "./VueSelect.vue?vue&type=script&lang=js&"
export * from "./VueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports